/**
 * Enumeration for the driver key types.
 *
 * @readonly
 * @enum {string}
 */
export const DriverKeyTypes = Object.freeze({
    IBUTTON: 'IBUTTON',
    GENERIC: 'GENERIC'
})
